// extracted by mini-css-extract-plugin
module.exports = {"score-mark":"Highlight_score-mark__112yp","score-s-mark":"Highlight_score-s-mark__2vH_m","children":"Highlight_children__BeOVa"};